module.exports = __webpack_public_path__ + "f9466f087fa82fc25cf7981bedfcf5a3.png";